import { render } from "./AdPlacementTypeList.vue?vue&type=template&id=78cb4796"
import script from "./AdPlacementTypeList.vue?vue&type=script&lang=js"
export * from "./AdPlacementTypeList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__